import * as actionTypes from "Redux/Actions/actionTypes";

const getAccount = (callback = () => {}) => ({
  type: actionTypes.GET_ACCOUNT,
  callback,
});

const getAccountData = (accountId, callback = () => {}) => ({
  type: actionTypes.GET_ACCOUNT_DATA,
  accountId,
  callback,
});

export { getAccount, getAccountData };
